import { AppUpdateNotifier } from '#components/AppUpdateNotifier.js'
import { useAuth } from '#context/Auth.tsx'
import { ArrowLeftToLine, Home, LogOut } from 'lucide-preact'
import { ValueLoading } from './ValueLoading.tsx'

import './Navbar.css'

export const Navbar = () => (
	<>
		<Nav />
		<AppUpdateNotifier />
	</>
)

const Nav = () => {
	const auth = useAuth()
	return (
		<div class="topNav mb-4">
			<nav class="left">
				<img
					src="/static/images/nRF-Cloud-powered-by-Memfault-flat.svg"
					alt="nRF Cloud"
					class="logo"
				/>
				<a href="https://app.nrfcloud.com/#/dashboard">
					<ArrowLeftToLine /> back to Dashboard
				</a>
				<a href="/" class="ms-2">
					<Home /> Teams
				</a>
			</nav>
			<span class="right">
				<ValueLoading value={auth.oidcUser} height={22} width={250}>
					<nav class="right">
						{auth.oidcUser?.profile.email}
						{name !== undefined ? (
							<span class="ms-2">({auth.oidcUser?.profile.name})</span>
						) : null}
						<button
							type="button"
							class="btn btn-danger"
							onClick={() => auth.logout()}
						>
							<LogOut class="me-2" />
							Logout
						</button>
					</nav>
				</ValueLoading>
			</span>
		</div>
	)
}
